import { DbStatusType } from '../types/db-status.type';

export interface Event {
  id: string;
  date: Date | null;
  dbStatus: DbStatusType;
  horseId: string;
  prePurchaseExam?: PrePurchaseExam;
  recordings: string[];
  removed?: string[];
}

export class EventClass implements Event {
  id: string;
  date: Date | null;
  dbStatus: DbStatusType;
  horseId: string;
  prePurchaseExam?: PrePurchaseExam | undefined;
  recordings: string[];
  removed?: string[] | undefined;

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    this.date = o['date'] ? new Date(o['date']) : null;
    this.dbStatus = o['dbStatus'] ?? null;
    this.horseId = o['horseId'] ?? null;
    this.recordings = o['recordings'] ?? [];
    this.prePurchaseExam = o['prePurchaseExam'] ?? null;
    this.removed = o['removed'] ?? [];
  }
}

export interface PrePurchaseExam {
  fileName: string;
  prePurchaseExamUrl: string;
  status: string;
}

export interface InternalEventCreation {
  horseId: string;
  date: string;
  uploadedBy: string;
  recordingId: string;
}
